import { useMutation } from 'react-query'
import { type ClientPersistence } from '../../../../types/persistence/client-persistence'
import { api } from '../../../api'

const updateClient = async (id: number, data: ClientPersistence) => {
  const response = await api.put(`/clients/${id}`, data)
  return response.data
}

export const useClientEditMutation = () => {
  return useMutation('update-client', {
    mutationFn: ({ id, data }: { id: number, data: ClientPersistence }) => {
      return updateClient(id, data)
    },
  })
}
